import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "max",
})
export class MaxPipe implements PipeTransform {
  transform(items: any[], attr: string): any {
    if (!Array.isArray(items) || items.length === 0) {
      return items;
    }
    if (attr) {
      items.sort((a, b) => b[attr] - a[attr]);
      return items[0][attr];
    } else {
      items.sort((a, b) => b - a);
      return items[0];
    }
  }
}
